// Längenregeln für Konto-Passwörter — eine Quelle für Server (Richtlinie,
// better-auth) und Editor (minLength der Felder, Platzhaltertexte).
export const PASSWORD_MIN_LENGTH = 10;
export const PASSWORD_MAX_LENGTH = 128;
